import React from 'react';
import { observer } from 'mobx-react';
import { config } from '../../config';

// Helpers
import { closeDrawer, getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import { FeatureFlag } from "react-launch-darkly";

// Components
import * as icons from '../Icons/Icons';

const ScheduleRB = observer(class ScheduleRB extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.complete = this.complete.bind(this);
    this.renderDisabled = this.renderDisabled.bind(this);
    this.renderEnabled = this.renderEnabled.bind(this);
  }

  componentWillMount() {
    const { reschedule, store } = this.props;
    const { ExamStore } = store;

    this.state = {
      complete: false
    };

    let examSid, sessionSid, proctorLocationSid;

    if(!reschedule) {
      examSid = getURLSegment(this, 3);
      sessionSid = getURLSegment(this, 5);
      proctorLocationSid = this.props.proctorLocationSid;
    } else {
      examSid = ExamStore.examSession.examSid;
      sessionSid = ExamStore.examSession.sid;
      proctorLocationSid = ExamStore.examSession.location.sid;
    }

    this.props.store.ScheduleStore.getSchedulingToken(examSid, sessionSid, proctorLocationSid);
  }

  complete(e) {
    // In some cases, MS Edge seems to have a problem with opening
    // the new window, so we’re wrapping this in a try…catch to hopefully
    // allow the natural link element to just open if the JS open fails
    try {
      const _this = this;
      const win = window.open(e.target.getAttribute('href'));

      e.preventDefault();

      const int = setInterval(function(){
        try {
          // If the created window has been redirected to the domain
          // close the window, clear the interval, and set the state
          if(win.location.href && win.location.href === config.rbRedirect) {
            win.close();
            clearInterval(int);
            _this.setState({
              complete: true
            });

            // Hide the close button so the student has to click
            // the return to dashboard button
            _this.props.store.SessionStore.hideDrawerClose = true;
          } else if (win === null || win.closed) {
            clearInterval(int);
          }
        } catch (e) {}
      }, 1000);
    } catch (e) {
      // Let the natural link do its thing
      console.warn('window.open didn’t work.')
    }
  }

  renderDisabled() {
    const { translation } = this.props;

    return (
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">{translation.disabled.heading}</h1>
          </div>
        </header>

        <div className="panel panel--medium">
          <img className="panel__img" src="./static/img/logo-registerblast.png" width="200" alt="RegisterBlast" />

          <p>{translation.disabled.body}</p>
        </div>
      </div>
    )
  }

  renderEnabled() {
    const { reschedule, translation } = this.props;
    const { ScheduleStore, SessionStore, StudentStore } = this.props.store;

    if(!SessionStore.backgroundLoading) {
      if(!this.state.complete) {
        return (
          <div className="drawer__content">
            <header className="drawer__header">
              <div className="wrap">
                {!reschedule &&
                  <h1 className="drawer__title">{translation.heading}</h1>
                }

                {reschedule &&
                  <h1 className="drawer__title">{translation.heading_reschedule}</h1>
                }
              </div>
            </header>

            <div className="panel panel--medium">
              <img className="panel__img" src="./static/img/logo-registerblast.png" width="200" alt="RegisterBlast" />

              {!reschedule &&
                <div>
                  <p>{translation.intro}</p>

                  <h4 className="drawer__subheading">{translation.next_steps}</h4>

                  <ol>
                    {translation.steps.map(
                      (step, i) =>
                      <li key={i}>
                        <p>{step.body}</p>

                        {step.note &&
                          <p><strong>{step.note}</strong></p>
                        }
                      </li>
                    )}
                  </ol>
                </div>
              }

              {reschedule &&
                <p>{translation.intro_reschedule}</p>
              }

              <a
                className="btn btn--icn-right"
                href={
                  reschedule ? ScheduleStore.schedulingURL.replace('/schedule', '/reschedule') : ScheduleStore.schedulingURL
                }
                target="_blank"
                onClick={(e) => this.complete(e)}
              >
                {translation.button}
                <icons.iconCircleRight />
              </a>
            </div>
          </div>
        );
      } else {
        return (
          <div className="drawer__content">
            <header className="drawer__header">
              <div className="wrap">
                <h1 className="drawer__title">{translation.heading}</h1>
              </div>
            </header>

            <div className="panel panel--brief">
              <img className="panel__img" src="./static/img/logo-registerblast.png" width="200" alt="RegisterBlast" />

              <h2 className="panel__title">{translation.confirmed.heading}!</h2>

              <p>{translation.confirmed.body}</p>

              <a
                className="btn btn--icn-right"
                href="#app"
                onClick={(e) => {closeDrawer(e, this.props.parent, '/', StudentStore.getStudentExams)}}
              >
                {translation.confirmed.button}
                <icons.iconCircleRight />
              </a>
            </div>
          </div>
        )
      }
    }

    return null;
  }

  render() {
    return (
      <FeatureFlag
        flagKey="disable-register-blast"
        renderFeatureCallback={this.renderDisabled}
        renderDefaultCallback={this.renderEnabled}
      />
    )
  }
})

export default translate('ScheduleRB')(ScheduleRB);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ScheduleRB.js